<template>
    <el-dialog :title="title+' 【'+role.rolename+'】'" :visible="showflag" :width="width" @close="closeDialog">
        <el-tabs v-model="activeName" type="card">
            <el-tab-pane :label="fmenu.menu.name" :name="fmenu.menu.name" v-for="fmenu in menuData" :key="'f'+fmenu.menu.id">
                <el-table :data="fmenu.child" border style="width: 100%">
                    <el-table-column label="菜单" min-width="15%">
                        <template slot-scope="scope">
                            <el-checkbox v-model="checkedIds" name="menuid" :label="scope.row.menu.id">{{scope.row.menu.name}}</el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="按钮" min-width="30%">
                        <template slot-scope="scope">
                            <el-checkbox v-model="checkedIds" name="menuid" :label="bMenu.id" v-for="bMenu in scope.row.btnList" :key="'b'+bMenu.id" border size="mini">{{bMenu.name}}</el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" min-width="45%">
                        <template slot-scope="scope">
                            <el-checkbox v-model="checkedIds" name="menuid" :label="bMenu.id" v-for="bMenu in scope.row.labList" :key="'l'+bMenu.id" border size="mini">{{bMenu.name}}</el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog" size="medium">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getRoleMenuData } from '@/api/role'
import { saveModel } from '@/api/common'

export default {
    name: "roleMenu",
    mixins: [editutil],
    data() {
        return {
            activeName: 'first',
            model: {},
            role: {},
            menuData: [],
            checkedIds: []
        }
    },
    methods: {
        loadData(){
            this.menuData = []
            this.checkedIds = []
            getRoleMenuData(this.id).then(res=>{
                if(res.code == 1){
                    this.role = res.data.role
                    this.menuData = res.data.allMenu
                    this.checkedIds = res.data.checkedIds
                    this.activeName = this.menuData[0].menu.name
                }
            })
        },
        //保存方法
        handleSubmit() {
            let config = {
                url:'/api/admin/role/saveJurisdiction',
                data: {
                    checkedIds: this.checkedIds,
                    roleId: this.id
                }
            }
            saveModel(config).then(res=>{
                if(res.code===1){
                    this.$msgs("保存成功！");
                    this.closeDialog()
                }else{
                    this.$msg(res.msg)
                }
            }).catch();
        },
    }
};
</script>

<style lang="less" scoped>
    .el-checkbox {
        margin-right: 4px;
    }
</style>